import BaseModel from '../core/BaseModel'
export default class CategoriesModel extends BaseModel {
    constructor() {
        super({ 
                name: "categories",
                tableName: 'core_category',
                display_key: 'name'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false,
                width: 10,
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Nhóm sản phẩm',
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                width: 30,
            },
            is_manually_verification: {
                name: 'is_manually_verification', label: 'Nghiệm thu', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select',  display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status: {
                name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            }
        },)
    }

}